import {
  BatchReminderLetterConditionListItem,
  BatchReminderListConditionLetterItemFromJSON
} from '@/api/models/batch/BatchReminderLetterConditionListItem'

export interface BatchReminderLetterPageLoadResult {
  items: BatchReminderLetterConditionListItem
}

export function BatchReminderLetterPageLoadResultFromJSON(
  json: any
): BatchReminderLetterPageLoadResult {
  return {
    items: BatchReminderListConditionLetterItemFromJSON(json)
  }
}
